declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../../services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../services/actor.service';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { NgbAddCredentialsModal } from './addcredentials.modal';
import { NgbEditCredentialsModal } from './editcredentials.modal';
import { NgbAddsuplMaterialsModal } from './addsuplmaterials.modal';
import { NgbEditsuplMaterialsModal } from './editsuplmaterials.modal';
import { SaveVendorInformationRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'ngbaddvendor',
  templateUrl: './addvendor.modal.html',
  styleUrls: ['./addvendor.modal.scss']
})

export class NgbAddVendorModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  searchTitle: string;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
  CurrentSaveVendorInformationRequest = new SaveVendorInformationRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private spinner: NgxSpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {

    //this.CurrentSaveVendorInformationRequest = new SaveVendorInformationRequest();
    //this.CurrentSaveVendorInformationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  } 

  AddNewCredential() {

    const modalRef = this.modalService.open(NgbAddCredentialsModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }

  EditNewCredential() {

    const modalRef = this.modalService.open(NgbEditCredentialsModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  } 

  AddNewsuplMaterials() {

    const modalRef = this.modalService.open(NgbAddsuplMaterialsModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }

  EditNewsuplMaterials() {

    const modalRef = this.modalService.open(NgbEditsuplMaterialsModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }

  onSubmit() {

    this.spinner.show();
    this.actorservice.SaveVendorInformation(this.CurrentSaveVendorInformationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();            
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.spinner.hide();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();
          }
        }
      );


  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
